import { citySchema } from "@/schemas/city-schema";
import { IFetchCityResultResult } from "@/types/cities-type";

export const fechCities = async (): Promise<IFetchCityResultResult> => {
	try {
		const res = await fetch(
			"https://kuwait.exelys.io/metadata/kuwait_stations.geojson",
		);

		if (!res.ok) {
			throw new Error("Une erreur est survenue");
		}

		const data = await res.json();

		const validatedData = citySchema.parse(data);

		const { features } = validatedData;

		return {
			error: null,
			cityData: features.map((item) => {
				return item;
			}),
			isLoading: false,
		};
	} catch {
		return {
			error: "Une erreur est survenue",
			cityData: [],
			isLoading: false,
		};
	}
};
